import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
import WhatIs from './components/WhatIs';
import Benefits from './components/Benefits';
import Comparison from './components/Comparison';
import CategoriesSection from './components/CategoriesSection';
import Safety from './components/Safety';
import FAQ from './components/FAQ';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import SEOMeta from '@/components/base/SEOMeta';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://usfansspreadsheet.study';

const homeSeo = {
  title: 'USFansSpreadsheet – Poradnik, Recenzje i Narzędzia 2026',
  description: 'Poznaj USFansSpreadsheet. Kompletny przewodnik, recenzje, porównania, bezpieczeństwo, szablony i najlepsze praktyki dla użytkowników USFansSpreadsheet w 2026 roku.',
  keywords: 'usfansspreadsheet, usfansspreadsheet poradnik, usfansspreadsheet recenzja, usfansspreadsheet bezpieczeństwo, usfansspreadsheet alternatywy',
  canonicalUrl: SITE_URL + '/',
  ogType: 'website' as const,
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'USFansSpreadsheet',
  url: SITE_URL,
  description: homeSeo.description,
  inLanguage: 'pl-PL',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: SITE_URL + '/artykul/{search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <SEOMeta {...homeSeo} />
      <JsonLd data={websiteSchema} />
      <Navbar />
      <Hero />
      <TrustBadges />
      <WhatIs />
      <Benefits />
      <Comparison />
      <CategoriesSection />
      <Safety />
      <FAQ />
      <ArticlesSection />
      <CTASection />
      <Footer />
    </main>
  );
}